import { useState, useEffect } from "react";
//import { useState, useEffect } from "react";
import TextField from "../../Components/common/TextField/TextField";
import { Link } from "react-router-dom";
import CheckBox from "../../Components/common/CheckBox/CheckBox";
import CardForm from "../../Components/common/CardForm/CardForm";
import { useDispatch, useSelector } from "react-redux";
import { loginRequest, createSuperAdminRequest } from "../../store/actions/usersActions";
import { RequestGetLdapStatus } from "../../store/actions/settingsActions";
import Backdrop from "../../Components/UI/Backdrop/Backdrop";
import { licenceCheckRequest, licenceRegRequest } from "../../store/actions/usersActions";
//import { loadFromLocalStorage } from "../../utils/localStorage";
import packageJson from "../../../package.json";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { RequestUserServiceConnected } from "../../store/actions/containerActions";
import { addNotification } from "../../store/actions/notifierActions";

const LdapSignIn = () => {
  const dispatch = useDispatch();
  const error = useSelector((state) => state?.users.loginError);
  const loading = useSelector((state) => state?.users.loginLoading);
  const licenceCheck = useSelector((state) => state?.users.licenceCheck);
  const user = useSelector((state) => state?.users.user);
  const isUserServiceConnected = useSelector((state) => state.container.isUserServiceConnected);
  const ldapStatusActive = useSelector((state) => state?.settings.ldapStatusActive);
  const ldapStatusLoading = useSelector((state) => state?.settings.ldapStatusLoading);

  // Check if LDAP is truly active (configured and enabled)
  useEffect(() => {
    dispatch(RequestUserServiceConnected());
  }, []);

  //** THIS SECTION CREATE SUPERADMIN FOR OLD SYSTEM ****/
  useEffect(() => {
    dispatch(createSuperAdminRequest());
  }, []);
  //** THIS SECTION CREATE SUPERADMIN FOR OLD SYSTEM ****/

  useEffect(() => {
    dispatch(licenceCheckRequest());
    dispatch(RequestGetLdapStatus());
  }, []);

  const [inputs, setInputs] = useState({
    email: "",
    password: "",
  });
  const [checked, setChecked] = useState(false);
  const [inputsKey, setInputsKey] = useState({
    licencekey: "",
  });

  if (isUserServiceConnected === true) {
    // console.log('This is a log message.');
    if (user !== null) {
      return <Redirect to="/newdash" />;
    }
  } else {
    const handleChanges = (e) => {
      const { name, value } = e.target;
      setInputs((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    const handleChangesKey = (e) => {
      const { name, value } = e.target;
      setInputsKey((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    const submitFormHandler = (e) => {
      e.preventDefault();
      if (ldapStatusLoading) {
        dispatch(
          addNotification({
            message: "Still checking whether LDAP is enabled, please try again in a moment",
            options: { variant: "info" },
          }),
        );
        return;
      }
      if (ldapStatusActive) {
        dispatch(loginRequest({ ...inputs, checked, login_method: "ldap" }));
      } else {
        dispatch(addNotification({ message: "LDAP is not active", options: { variant: "error" } }));
      }
    };

    const submitFormHandlerKey = (e) => {
      e.preventDefault(); // Don't forget to prevent default form submission
      dispatch(licenceRegRequest(inputsKey.licencekey));
    };

    return licenceCheck?.theme ? (
      licenceCheck?.theme && (
        <CardForm
          error={error}
          title="Welcome Back! (LDAP Login)"
          subTitle={"Sign in using your LDAP credentials"}
          errorText=" Invalid username or password, please try again.">
          <form onSubmit={submitFormHandler}>
            <TextField
              placeholder="Enter your username or email"
              value={inputs.email}
              onChange={handleChanges}
              labelText="Username or Email"
              name="email"
              required={true}
              error={error}
              disabled={false}
            />
            <TextField
              placeholder="Enter your password"
              value={inputs.password}
              onChange={handleChanges}
              labelText="Password"
              name="password"
              required={true}
              error={error}
              type="password"
              disabled={false}
            />
            <CheckBox
              checked={checked}
              setChecked={setChecked}
              text={"Remember me"}
              disabled={false}
            />
            <button className="card__form-btn" type="submit">
              Sign In
            </button>
            <p style={{ textAlign: "center" }}>🔒 Passwords are managed by your organization.</p>
            <p style={{ textAlign: "center" }}>
              <span>&larr;</span> <Link to="/">Back to regular login</Link>
            </p>
            <p style={{ textAlign: "center" }}>v{packageJson.version}</p>
          </form>
          {loading && <Backdrop show={loading} />}
        </CardForm>
      )
    ) : (
      <CardForm
        error={error}
        title="Welcome!"
        subTitle="Please enter the license key you received from our team in the box below."
        errorText=" Invalid username or password, please try again.">
        <form onSubmit={submitFormHandlerKey}>
          <TextField
            placeholder="Enter your licence key"
            value={inputsKey.licencekey}
            onChange={handleChangesKey}
            labelText="Licence Key"
            name="licencekey"
            required={true}
            error={error}
          />
          <button className="card__form-btn" type="submit">
            Submit
          </button>
        </form>
        {loading && <Backdrop show={loading} />}
      </CardForm>
    );
  }
};

export default LdapSignIn;
